import { render, staticRenderFns } from "./AuthorContactUs.vue?vue&type=template&id=2ef7db31&scoped=true"
import script from "./AuthorContactUs.vue?vue&type=script&lang=js"
export * from "./AuthorContactUs.vue?vue&type=script&lang=js"
import style0 from "./AuthorContactUs.vue?vue&type=style&index=0&id=2ef7db31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef7db31",
  null
  
)

export default component.exports